/* SAGA BEAUTY — interacciones (vanilla, sin librerías) */
(function () {
  'use strict';
  var reducido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Reveals al hacer scroll ---------------------------------------------- */
  var ioReveal = null;
  function mostrarSiVisible() {
    // red de seguridad: lo que ya está en pantalla se muestra aunque el observador no haya avisado
    var h = window.innerHeight;
    document.querySelectorAll('.sg-reveal:not(.sg-visible)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < h - 20 && r.bottom > 0) el.classList.add('sg-visible');
    });
  }
  function initReveals(root) {
    var els = (root || document).querySelectorAll('.sg-reveal:not(.sg-visible)');
    if (!els.length) return;
    if (reducido || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('sg-visible'); });
      return;
    }
    if (!ioReveal) {
      ioReveal = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('sg-visible'); ioReveal.unobserve(e.target); }
        });
      }, { threshold: 0.05, rootMargin: '0px 0px -40px 0px' });
      var t = null;
      window.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(mostrarSiVisible, 120); }, { passive: true });
      // si alguna sección se vuelve a pintar (editor, recarga en caliente), observar sus elementos nuevos
      if ('MutationObserver' in window) {
        new MutationObserver(function (muts) {
          muts.forEach(function (m) {
            m.addedNodes.forEach(function (n) { if (n.nodeType === 1) { if (n.matches('.sg-reveal')) ioReveal.observe(n); n.querySelectorAll && n.querySelectorAll('.sg-reveal:not(.sg-visible)').forEach(function (x) { ioReveal.observe(x); }); } });
          });
        }).observe(document.body, { childList: true, subtree: true });
      }
    }
    els.forEach(function (el) { ioReveal.observe(el); });
    setTimeout(mostrarSiVisible, 300);
  }

  /* Header: sombra al hacer scroll + menú móvil --------------------------- */
  function initHeader() {
    var wrap = document.querySelector('.sg-header-wrap');
    if (!wrap) return;
    var header = wrap.querySelector('.sg-header');
    var burger = wrap.querySelector('.sg-burger');
    var onScroll = function () { header.classList.toggle('sg-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    if (burger) {
      burger.addEventListener('click', function () {
        var r = header.getBoundingClientRect();
        wrap.style.setProperty('--sg-cajon-top', Math.max(0, r.bottom) + 'px');
        var abierto = wrap.classList.toggle('sg-menu-abierto');
        burger.setAttribute('aria-expanded', abierto ? 'true' : 'false');
        document.documentElement.style.overflow = abierto ? 'hidden' : '';
      });
      wrap.querySelectorAll('.sg-cajon a').forEach(function (a) {
        a.addEventListener('click', function () {
          wrap.classList.remove('sg-menu-abierto');
          burger.setAttribute('aria-expanded', 'false');
          document.documentElement.style.overflow = '';
        });
      });
    }
  }

  /* Hero: carrusel de banners -------------------------------------------- */
  function initHero() {
    document.querySelectorAll('[data-sg-hero]').forEach(function (hero) {
      if (hero.dataset.sgListo) return;
      hero.dataset.sgListo = '1';
      var slides = hero.querySelectorAll('.sg-slide');
      var puntos = hero.querySelectorAll('.sg-hero__punto');
      var num = hero.querySelector('.sg-hero__num-actual');
      if (!slides.length) return;
      var actual = 0, timer = null;
      var vel = (parseFloat(hero.dataset.velocidad) || 6) * 1000;
      var auto = hero.dataset.auto === 'true' && slides.length > 1;

      function ir(i) {
        actual = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-activa', k === actual); s.setAttribute('aria-hidden', k === actual ? 'false' : 'true'); });
        puntos.forEach(function (p, k) {
          p.classList.remove('is-activo'); void p.offsetWidth;
          if (k === actual) p.classList.add('is-activo');
        });
        if (num) num.textContent = String(actual + 1).padStart(2, '0');
        var s = slides[actual];
        hero.style.setProperty('--sg-ctrl', s.dataset.ctrl || 'rgba(26,18,32,.22)');
        hero.style.setProperty('--sg-ctrl-on', s.dataset.ctrlOn || '#1A1220');
        programar();
      }
      function programar() {
        clearTimeout(timer);
        if (auto && !hero.classList.contains('sg-hero--pausa')) timer = setTimeout(function () { ir(actual + 1); }, vel);
      }
      puntos.forEach(function (p, k) { p.addEventListener('click', function () { ir(k); }); });
      var prev = hero.querySelector('[data-sg-prev]'), next = hero.querySelector('[data-sg-next]');
      if (prev) prev.addEventListener('click', function () { ir(actual - 1); });
      if (next) next.addEventListener('click', function () { ir(actual + 1); });
      hero.addEventListener('mouseenter', function () { if (auto) { hero.classList.add('sg-hero--pausa'); clearTimeout(timer); } });
      hero.addEventListener('mouseleave', function () { if (auto) { hero.classList.remove('sg-hero--pausa'); ir(actual); } });
      // deslizar con el dedo
      var x0 = null;
      hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      hero.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 50) ir(actual + (dx < 0 ? 1 : -1));
        x0 = null;
      });
      // en el editor de Shopify: mostrar el banner seleccionado
      hero.addEventListener('shopify:block:select', function (e) {
        var idx = Array.prototype.indexOf.call(slides, e.target.closest('.sg-slide'));
        if (idx > -1) { auto = false; ir(idx); }
      });
      ir(0);
    });
  }

  /* Catálogo: filtros por categoría y marca ------------------------------ */
  var catalogos = [];
  function initCatalogo() {
    document.querySelectorAll('[data-sg-catalogo]').forEach(function (cat) {
      if (cat.dataset.sgListo) return;
      cat.dataset.sgListo = '1';
      var prods = cat.querySelectorAll('.sg-prod');
      var vacio = cat.querySelector('.sg-cat-vacio');
      var vacioNombre = cat.querySelector('[data-sg-vacio-nombre]');
      var vacioBtn = cat.querySelector('[data-sg-vacio-btn]');
      var estado = { cat: 'todos', marca: 'todas', catNombre: '' };

      // contadores
      cat.querySelectorAll('[data-sg-filtro-cat]').forEach(function (b) {
        var tag = b.dataset.sgFiltroCat, n = 0;
        prods.forEach(function (p) { if (tag === 'todos' || (p.dataset.tags || '').split('|').indexOf(tag) > -1) n++; });
        var c = b.querySelector('.sg-chip__n'); if (c) c.textContent = n;
      });

      function aplicar() {
        var visibles = 0;
        prods.forEach(function (p) {
          var tags = (p.dataset.tags || '').split('|');
          var okCat = estado.cat === 'todos' || tags.indexOf(estado.cat) > -1;
          var okMarca = estado.marca === 'todas' || p.dataset.marca === estado.marca;
          var ok = okCat && okMarca;
          var antes = !p.classList.contains('is-oculto');
          p.classList.toggle('is-oculto', !ok);
          if (ok) { visibles++; if (!antes) { p.classList.remove('is-entrando'); void p.offsetWidth; p.classList.add('is-entrando'); } }
        });
        if (vacio) {
          vacio.classList.toggle('is-visible', visibles === 0);
          if (vacioNombre) vacioNombre.textContent = estado.catNombre || 'esta línea';
          if (vacioBtn) vacioBtn.setAttribute('href', '#contacto?linea=' + encodeURIComponent(estado.catNombre || ''));
        }
        cat.querySelectorAll('[data-sg-filtro-cat]').forEach(function (b) { b.classList.toggle('is-activo', b.dataset.sgFiltroCat === estado.cat); });
        cat.querySelectorAll('[data-sg-filtro-marca]').forEach(function (b) { b.classList.toggle('is-activo', b.dataset.sgFiltroMarca === estado.marca); });
      }
      cat.querySelectorAll('[data-sg-filtro-cat]').forEach(function (b) {
        b.addEventListener('click', function () { estado.cat = b.dataset.sgFiltroCat; estado.catNombre = b.dataset.nombre || ''; aplicar(); });
      });
      cat.querySelectorAll('[data-sg-filtro-marca]').forEach(function (b) {
        b.addEventListener('click', function () { estado.marca = estado.marca === b.dataset.sgFiltroMarca ? 'todas' : b.dataset.sgFiltroMarca; aplicar(); });
      });
      catalogos.push({
        el: cat,
        filtrar: function (opts) {
          if (opts.cat) {
            estado.cat = opts.cat;
            var b = cat.querySelector('[data-sg-filtro-cat="' + opts.cat + '"]');
            estado.catNombre = b ? (b.dataset.nombre || '') : (opts.nombre || '');
          }
          if (opts.marca) estado.marca = opts.marca;
          if (opts.cat && !opts.marca) estado.marca = 'todas';
          if (opts.marca && !opts.cat) { estado.cat = 'todos'; estado.catNombre = ''; }
          aplicar();
        }
      });
      aplicar();
    });
  }

  /* Formulario: rellenar producto / línea de interés --------------------- */
  function rellenarFormulario(params) {
    var form = document.querySelector('[data-sg-form]');
    if (!form) return;
    var prod = form.querySelector('[data-sg-campo-producto]');
    var linea = form.querySelector('[data-sg-campo-linea]');
    var marca = form.querySelector('[data-sg-campo-marca]');
    if (params.producto && prod) { prod.value = params.producto; prod.classList.remove('sg-resaltado'); void prod.offsetWidth; prod.classList.add('sg-resaltado'); }
    if (params.linea && linea) {
      Array.prototype.forEach.call(linea.options, function (o) { if (o.value.toLowerCase() === params.linea.toLowerCase()) linea.value = o.value; });
    }
    if (params.marca && marca) {
      Array.prototype.forEach.call(marca.options, function (o) { if (o.value.toLowerCase().indexOf(params.marca.toLowerCase()) > -1) marca.value = o.value; });
    }
  }

  /* Enlaces especiales: #catalogo?cat=..&marca=..  y  #contacto?producto=.. */
  function parsearHash(hash) {
    if (!hash || hash.charAt(0) !== '#') return null;
    var partes = hash.slice(1).split('?');
    var destino = decodeURIComponent(partes[0]);
    var params = {};
    if (partes[1]) partes[1].split('&').forEach(function (kv) {
      var p = kv.split('='); if (p[0]) params[decodeURIComponent(p[0])] = decodeURIComponent((p[1] || '').replace(/\+/g, ' '));
    });
    return { destino: destino, params: params };
  }
  function irA(info, suave) {
    if (!info) return false;
    var el = document.getElementById(info.destino);
    if (!el) return false;
    if (info.destino === 'catalogo' && (info.params.cat || info.params.marca)) {
      catalogos.forEach(function (c) { c.filtrar({ cat: info.params.cat, marca: info.params.marca }); });
    }
    if (info.destino === 'contacto') rellenarFormulario(info.params);
    var header = document.querySelector('.sg-header-wrap');
    var off = header ? header.getBoundingClientRect().height + 10 : 0;
    var y = el.getBoundingClientRect().top + window.scrollY - off;
    window.scrollTo({ top: y, behavior: suave && !reducido ? 'smooth' : 'auto' });
    return true;
  }
  function initEnlaces() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href*="#"]');
      if (!a) return;
      var href = a.getAttribute('href');
      var i = href.indexOf('#');
      var ruta = href.slice(0, i);
      if (ruta && ruta !== '/' && ruta !== window.location.pathname) return; // otra página: navegar normal
      if (ruta === '/' && window.location.pathname !== '/') return;
      var info = parsearHash(href.slice(i));
      if (info && irA(info, true)) {
        e.preventDefault();
        if (history.replaceState) history.replaceState(null, '', '#' + info.destino);
      }
    });
    // al llegar desde otra página con #catalogo?... o tras enviar el formulario
    var info = parsearHash(window.location.hash);
    if (info) setTimeout(function () { irA(info, false); }, 250);
    if (/contact_posted=true/.test(window.location.search) || document.querySelector('.sg-form__ok, .sg-form__error')) {
      setTimeout(function () { irA({ destino: 'contacto', params: {} }, false); }, 250);
    }
  }

  /* Galería de producto -------------------------------------------------- */
  function initGaleria() {
    document.querySelectorAll('[data-sg-galeria]').forEach(function (g) {
      var principal = g.querySelector('.sg-pp__principal img');
      g.querySelectorAll('.sg-pp__mini').forEach(function (m) {
        m.addEventListener('click', function () {
          g.querySelectorAll('.sg-pp__mini').forEach(function (x) { x.classList.remove('is-activo'); });
          m.classList.add('is-activo');
          principal.classList.add('is-cambiando');
          setTimeout(function () {
            principal.src = m.dataset.src; principal.srcset = m.dataset.srcset || '';
            principal.alt = m.dataset.alt || '';
            principal.classList.remove('is-cambiando');
          }, 250);
        });
      });
    });
  }

  /* Comparador antes / después ------------------------------------------- */
  function initComparador() {
    document.querySelectorAll('[data-sg-comparador]').forEach(function (comp) {
      if (comp.dataset.sgListo) return;
      comp.dataset.sgListo = '1';
      var rango = comp.querySelector('.sg-ad__rango');
      if (!rango) return;
      var tocado = false;
      var poner = function (v) { comp.style.setProperty('--pos', v + '%'); };
      rango.addEventListener('input', function () { tocado = true; poner(rango.value); });
      rango.addEventListener('pointerdown', function () { comp.classList.add('is-arrastrando'); });
      window.addEventListener('pointerup', function () { comp.classList.remove('is-arrastrando'); });
      // pequeña demostración la primera vez que se ve, para que se entienda que se puede deslizar
      if (reducido || !('IntersectionObserver' in window)) return;
      var inicio = parseFloat(rango.value) || 50;
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        var t0 = null, dur = 1800;
        function paso(t) {
          if (tocado) return;
          if (!t0) t0 = t;
          var k = Math.min(1, (t - t0) / dur);
          var v = inicio + Math.sin(k * Math.PI * 2) * 18 * (1 - k);
          poner(v); rango.value = v;
          if (k < 1) requestAnimationFrame(paso); else { poner(inicio); rango.value = inicio; }
        }
        setTimeout(function () { requestAnimationFrame(paso); }, 600);
      }, { threshold: 0.5 });
      io.observe(comp);
    });
  }

  function initTodo() { initReveals(); initHeader(); initHero(); initCatalogo(); initGaleria(); initComparador(); }
  document.addEventListener('DOMContentLoaded', function () { initTodo(); initEnlaces(); });
  // compatibilidad con el editor de Shopify
  document.addEventListener('shopify:section:load', function (e) {
    initReveals(e.target);
    initHero(); initCatalogo(); initGaleria(); initComparador();
    if (e.target.querySelector('.sg-header-wrap')) initHeader();
  });
})();
